import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Modal, FormLayout, Tabs, Card, Form, Select} from '@shopify/polaris';
import { useFormik } from 'formik';
import BasicTextField from '@presentational/BasicTextField';

import { ta } from 'utils';
import { SellerApplicationFormUpdateSchema } from 'utils/validationSchemas';
import pick from 'lodash/pick';

// import Form from './Form';

const propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,

  currencies: PropTypes.array.isRequired, // catalog

  record: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    company_name: PropTypes.string.isRequired,
    bank_account_number: PropTypes.string,
  }).isRequired,
}

const defaultProps = {

}

const UpdateModalForm = (props) => {
  const formik = useFormik({
    initialValues: props.record,
    validationSchema: SellerApplicationFormUpdateSchema,
    onSubmit: props.onSubmit
  });

  useEffect( () => {
    if(!props.open){
      console.log("RESET")
      formik.resetForm({values: props.record});
    }
  }, [props.open]);

  const sharedFieldProps = {
    ...pick(formik, ['values', 'touched', 'errors', 'handleBlur']),
    handleChange: formik.setFieldValue
  }

  console.log("F", formik);

  return (
    <Modal
      open={ props.open }
      large
      title={ props.title }
      onClose={ props.onClose }

      primaryAction={{
        content: I18n.t("actions.save"),
        onAction: formik.handleSubmit,
        disabled: false,
      }}
      secondaryActions={{
        content: I18n.t("actions.cancel"),
        onAction: props.onClose,
      }}
    >
      <Form onSubmit={ formik.handleSubmit }>
        <Card sectioned>
          <FormLayout>
            <BasicTextField invertHandleChange name="company_name" placeholder={ ta("seller_application_form.company_name") } label={ ta("seller_application_form.company_name") } {...sharedFieldProps} />
            <BasicTextField invertHandleChange name="bank_account_number" placeholder={ ta("seller_application_form.bank_account_number") } label={ ta("seller_application_form.bank_account_number") } {...sharedFieldProps} />

            <Select
              id="currency"
              label={ ta("general.currency") }
              options={ props.currencies }
              value={ sharedFieldProps.values.currency }
              onChange={ (value, id) => sharedFieldProps.handleChange(id, value) }
              error={ sharedFieldProps.errors.currency }
            />
          </FormLayout>
        </Card>
      </Form>
    </Modal>
  )
};

UpdateModalForm.propTypes = propTypes;
UpdateModalForm.defaultProps = defaultProps;

export default UpdateModalForm;